import type { FC } from 'react';
import { writePosition } from '../playbackPosition';
import { useStore } from '../store';
import { useInterval } from '../utils/hooks';

const SAVE_INTERVAL_MS = 5000;

/**
 * Remembers where the viewer is watching, so a reload picks the position up again. The url stays
 * out of this on purpose — writing the time into the hash would rewrite it on every timer tick.
 * See `getPositionToRestore` for the restore side. Mounted by the player only, not by the
 * embedded elevation chart.
 */
export const PlaybackPositionManager: FC = () => {
  // Deliberately does not subscribe to timer.time: it changes ~20x per second, which would
  // re-render this component on every tick. Sampling the store on an interval instead keeps the
  // cost at one small write per SAVE_INTERVAL_MS and zero re-renders.
  useInterval(() => {
    const { eventId, timer } = useStore.getState();
    if (eventId === '') return;

    writePosition(eventId, timer);
  }, SAVE_INTERVAL_MS);

  return null;
};
